enum SituacaoEnum {
  admin = 'admin',
  agendamento = 'agendamento',
  agendamentoBackoffice = 'agendamentoBackoffice',
  assinarEnviar = 'assinarEnviar',
  instrumentador = 'instrumentador',
}

export default SituacaoEnum
